/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FaqSearchResponseDto } from '../../models/faq-search-response-dto';

export interface FaqControllerSearchV1$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 카테고리
 */
  category: 'ACCOUNT' | 'PAYMENT' | 'MY_CHILD' | 'CHILD_MANAGEMENT' | 'ETC' | 'ALL';

/**
 * 회원 역할
 */
  memberRole?: ('PARENT' | 'TEACHER') | null;
}

export function faqControllerSearchV1(http: HttpClient, rootUrl: string, params: FaqControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqSearchResponseDto>> {
  const rb = new RequestBuilder(rootUrl, faqControllerSearchV1.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('category', params.category, {});
    rb.query('memberRole', params.memberRole, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FaqSearchResponseDto>;
    })
  );
}

faqControllerSearchV1.PATH = '/api/v1/faq/search';
